import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight, Star, Quote, CalendarHeart, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "./Chapter";
import { REVIEWS } from "../lib/data";

export default function Avis() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });

  return (
    <section className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 bg-cream grain overflow-hidden" data-testid="section-avis">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div>
            <Chapter num="6" label="Les avis" />
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-ink">
                Vécu, aimé,<br />
                <span className="italic font-medium text-terra">recommandé.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-6 inline-flex items-center gap-3 rounded-full bg-sand border border-ink/10 px-5 py-2.5 shadow-sm">
                <span className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={15} className="fill-gold text-gold" />
                  ))}
                </span>
                <span className="text-sm font-semibold text-ink/70">Basé sur 437 avis Google</span>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.25} className="flex gap-3">
            <button
              onClick={() => emblaApi?.scrollPrev()}
              data-testid="avis-prev-button"
              className="grid place-items-center w-12 h-12 rounded-full border border-ink/15 text-ink transition-all duration-300 hover:bg-pine hover:text-sand hover:border-pine"
              aria-label="Avis précédent"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() => emblaApi?.scrollNext()}
              data-testid="avis-next-button"
              className="grid place-items-center w-12 h-12 rounded-full border border-ink/15 text-ink transition-all duration-300 hover:bg-pine hover:text-sand hover:border-pine"
              aria-label="Avis suivant"
            >
              <ChevronRight size={20} />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 overflow-hidden" ref={emblaRef} data-testid="avis-carousel">
            <div className="flex gap-6">
              {REVIEWS.map((r, i) => (
                <figure
                  key={i}
                  className={`min-w-0 flex-[0_0_88%] sm:flex-[0_0_46%] lg:flex-[0_0_31.5%] rounded-[1.75rem] bg-sand border border-ink/10 p-7 shadow-md shadow-ink/5 ${
                    i % 2 ? "rotate-1" : "-rotate-1"
                  } hover:rotate-0 transition-transform duration-500`}
                  data-testid={`avis-card-${i}`}
                >
                  <Quote size={22} className="text-terra" />
                  <blockquote className="mt-4 text-ink/75 text-sm leading-relaxed min-h-[7rem]">
                    {r.text}
                  </blockquote>
                  <figcaption className="mt-6 flex items-center justify-between">
                    <span className="font-display font-bold text-ink">{r.name}</span>
                    <span className="flex gap-0.5">
                      {[...Array(5)].map((_, s) => (
                        <Star key={s} size={12} className="fill-gold text-gold" />
                      ))}
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <Link
            to="/sejour-ideal"
            data-testid="avis-sejour-link"
            className="group mt-12 flex items-center justify-between gap-4 rounded-[1.75rem] bg-pine text-sand p-6 sm:p-7 transition-all duration-300 hover:bg-pinedark hover:-translate-y-1 hover:shadow-xl hover:shadow-pine/25"
          >
            <div className="flex items-center gap-4">
              <span className="grid place-items-center w-12 h-12 shrink-0 rounded-full bg-gold text-pinedark transition-transform duration-300 group-hover:-rotate-12">
                <CalendarHeart size={22} />
              </span>
              <div>
                <div className="font-display font-bold text-xl sm:text-2xl">Mon séjour idéal, jour par jour</div>
                <p className="text-sm text-sand/70 mt-0.5">
                  Une semaine type racontée par nos campeurs : marchés, dolmens, Conques, canoë…
                </p>
              </div>
            </div>
            <ArrowUpRight size={22} className="text-gold shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
